module.exports = __webpack_public_path__ + "static/img/SketchPng3cb615bb9f6eb3190dcd98779accd67ec6a0eb2b5067311455f1b874bdfd66f4.e5a2a679.png";